var map = {
	"./commercialreview-sm-black.png": 62678,
	"./commercialreview-sm-grey.png": 62654,
	"./commercialreview-sm-white.png": 28632,
	"./commercialreview-sm.png": 35704,
	"./commercialreview.png": 92289,
	"./stramigo-sm.png": 7680,
	"./stramigo.png": 26777
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65471;